export const ROLES = Object.freeze({
  CONTENT_CREATOR: "CONTENT_CREATOR",
  ADMIN: "ADMIN",
  SUB_ADMIN: "SUB_ADMIN",
});

export const CONTENT_STATUS = {
  DRAFT: "DRAFT",  
  IN_REVIEW: "IN_REVIEW", 
  CHANGES_REQUESTED: "CHANGES_REQUESTED",
  APPROVED: "APPROVED",
  PUBLISHED: "PUBLISHED",
  ARCHIVED: "ARCHIVED", 
  REJECTED: 'REJECTED'
};

export const CONTENT_TIER = {
  FREE: 'FREE',
  PREMIUM: 'PREMIUM',
  PPV: 'PAYPERVIEWS'
}
